import { render, staticRenderFns } from "./ReviewFeedbackPreview.vue?vue&type=template&id=5ef0af09&scoped=true&"
import script from "./ReviewFeedbackPreview.vue?vue&type=script&lang=js&"
export * from "./ReviewFeedbackPreview.vue?vue&type=script&lang=js&"
import style0 from "./ReviewFeedbackPreview.vue?vue&type=style&index=0&id=5ef0af09&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef0af09",
  null
  
)

export default component.exports